import { baseURL, getJSON, postData} from "./API"
import {apiClient, deleteRequest, getRequest} from "./AxiosConfig";

const apiMapping = "api/test";

export async function updateTest(data) {
    postData(apiMapping+"/update", {test:data});
}

export async function getAllTests() {
    return await getJSON(apiMapping+"/all");
}

export async function getNQuizByProduct(n) {
    return await getRequest( `/test/product/${n}`);
}

export async function getTestResult(id, setErrorMessage) {
    return await getRequest(`/test/result/${id}`, setErrorMessage);
}

export async function saveQuiz(quiz) {
    return await postData(apiMapping+"/save", quiz);
}

export async function getAllTags() {
    return await getJSON(apiMapping+"/tags");
}

export async function deleteQuiz(id, setErrorMessage) {
    return await deleteRequest(apiClient, "/test/delete/"+id, setErrorMessage);
}

export async function uploadQuizFile(file) {
    let formData = new FormData();
    formData.append('file', file);

    let response = await fetch(baseURL + "api/test/import", {
        withCredentials: "true",
        credentials: "include",
        body: formData,
        method: "POST"
    });
    return await response.json()
}